import { BinaryWriter, ProtocolError } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeMapChunk(packet, writer = new BinaryWriter(packet.tiles.length + 16)) {
    writer
        .u8(ServerOp.MapChunk)
        .u8(packet.z)
        .u16(packet.x)
        .u16(packet.y)
        .u8(packet.width)
        .u8(packet.height)
        .raw(packet.tiles);
    return writer;
}
export function decodeMapChunk(reader) {
    const z = reader.u8();
    const x = reader.u16();
    const y = reader.u16();
    const width = reader.u8();
    const height = reader.u8();
    const expected = width * height;
    if (reader.remaining < expected) {
        throw new ProtocolError(`MapChunk anuncia ${width}x${height} (${expected} tiles) mas só restam ${reader.remaining} bytes`);
    }
    return { z, x, y, width, height, tiles: reader.raw(expected) };
}
//# sourceMappingURL=map-chunk.js.map